import React from "react";
import { TextInput } from "ra-ui-materialui";
import { get } from "lodash";
import { required } from "ra-core";
import { useFormState } from "react-final-form";
import { useSelector } from "react-redux";

const StaffUserRoleOtherInput = (props) => {
  const formState = useFormState();
  const staffUserRoleId = formState.values?.staff_user_role_id;
  const type = formState.values?.type;
  const isCustom = useSelector((state) =>
    get(
      state,
      `admin.resources.staff-user-roles.data.${staffUserRoleId}.is_custom`,
      false
    )
  );
  if (!isCustom && type !== "private") {
    return null;
  }
  return (
    <TextInput
      maxLength={100}
      validate={required()}
      label={
        type === "public"
          ? undefined
          : "resources.research-project-staff-users.fields.staff_user_role_id"
      }
      {...props}
    />
  );
};
export default StaffUserRoleOtherInput;
